import { Injectable } from '@angular/core'
import { BaseProviderStatus, BaseShippingProviderService, ProviderStatusEntry } from '../shared/base-shipping-provider.service'

export interface SmsaSettings {
  enabled: boolean
  passKey: string
  originCountryCode: string
  originCityName: string
  originAddressLine: string
  originPhone: string
  flatRate: number | null
  baseRate: number | null
  perKgRate: number | null
  codEnabled: boolean
}

export interface SmsaSettingsStatus extends BaseProviderStatus {
  originCountryCode?: string
  originCityName?: string
  originAddressLine?: string
  originPhone?: string
  flatRate?: number
  baseRate?: number
  perKgRate?: number
  codEnabled?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class SmsaSettingsService extends BaseShippingProviderService<SmsaSettings, SmsaSettingsStatus> {
  protected readonly providerKey = 'smsa'
  protected readonly providerLabel = 'SMSA'

  protected mapStatus(entry: ProviderStatusEntry): SmsaSettingsStatus {
    return {
      connected: entry.connected,
      enabled: entry.enabled,
      originCountryCode: entry.originAddress?.countryCode,
      originCityName: entry.originAddress?.cityName,
      originAddressLine: entry.originAddress?.addressLine,
      originPhone: entry.originAddress?.phone,
      flatRate: entry.settings?.['flatRate'] as number | undefined,
      baseRate: entry.settings?.['baseRate'] as number | undefined,
      perKgRate: entry.settings?.['perKgRate'] as number | undefined,
      codEnabled: entry.settings?.['codEnabled'] as boolean | undefined
    }
  }

  protected buildSaveBody(projectId: string, settings: SmsaSettings): Record<string, unknown> {
    return {
      projectId,
      enabled: settings.enabled,
      passKey: settings.passKey,
      originCountryCode: settings.originCountryCode,
      originCityName: settings.originCityName,
      originAddressLine: settings.originAddressLine,
      originPhone: settings.originPhone,
      flatRate: settings.flatRate ?? undefined,
      baseRate: settings.baseRate ?? undefined,
      perKgRate: settings.perKgRate ?? undefined,
      codEnabled: settings.codEnabled,
    }
  }
}
